import { Pipe, PipeTransform } from '@angular/core';
import { Area } from '../models/types';

@Pipe({
  name: 'filterAreasByCity'
})
export class FilterAreasByCityPipe implements PipeTransform {

  transform(areas: Area[], city_id: string) {
    return city_id ?  areas.filter(areas => areas.city_id.indexOf(city_id) !== -1) : areas
  }

}
